import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { CampaignDetail } from '../outreachTypes';
import { useRetry } from './useRetry';

/** `outreach.campaigns.get` (frames e, h). `outreach.campaign.updated` reads it again. */
export function useCampaign(accountId: number, campaignUuid: string | null) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(
    trpcAPI.outreach.campaigns.get.queryOptions(
      { accountId, campaignUuid: campaignUuid ?? '' },
      { enabled: campaignUuid !== null, retry: false }
    )
  );
  const retry = useRetry(query.refetch);
  return {
    campaign: (query.data ?? undefined) as CampaignDetail | undefined,
    isLoading: query.isLoading,
    error: query.error,
    retry,
  };
}
